module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer legal-footer-padding"
  }, [_c('a', {
    staticClass: "company",
    attrs: {
      "href": _vm.url
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.address))]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_vm._v(_vm._s(_vm.contact))]), _vm._v(" "), _c('a', {
    staticClass: "terms",
    style: ({
      'color': _vm.primaryColor
    }),
    attrs: {
      "href": "/#/legal"
    }
  }, [_vm._v("Terms of Service")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70497e28","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/assets/pages/Company/Company.vue
// module id = 973
// module chunks = 3